module.exports = __webpack_public_path__ + "static/img/2.22d4b6d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/fgimg/2.jpg
// module id = T7Ok
// module chunks = 18